import { FC, useEffect, useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { useForm, useWatch } from 'react-hook-form';
import {
  Alert,
  Grid,
  Box,
  useTheme,
  Typography,
  Stepper,
  Step,
  StepButton,
  StepLabel,
  MenuItem,
  Divider,
  IconButton,
  FormHelperText,
  CircularProgress,
  Stack,
  Button,
  Paper
} from '@mui/material';
import {
  ArrowBackIosNew,
  ArrowForwardIos,
  CheckCircle,
} from '@mui/icons-material';
import moment from 'moment';
import {
  FormDateOb,
  FormAvailableDatesOb,
  FormDropdownOb,
  FormOnlineBookingButton,
  FormOnlineBookingLoadingButton,
  FormOtpPopUp,
  FormPhoneInputOb,
  FormRadioButton,
  FormSection,
  FormTextField,
  Loader,
  translateLanguage,
  FormOtpField,
  FormSectionOb,
  FormTextFieldOb
} from 'components';
import { DropdownOption, OnlineBookingContent } from 'models';
import { bookingPrepare } from 'utilities/onlineBooking';
import { RadioGroupBookingGender } from 'configs/online-booking-config';
import { DATEFORMAT, DATE_FORMAT_MDY } from 'constants/utilities';
import {
  onlineBookingAppointmentSchema,
  onlineBookingSearchSchema,
} from 'schema/online-booking-schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { decodedData, encodedData, formattedMobNumber } from 'utilities/utils';
import { DateFormaterYMD, formatDateDayDDMM } from 'utilities/formatDate';
import {
  onlineBookingAppointmentDefaultValues,
  onlineBookingSearchDefaultValues,
} from 'constants/formDefaultValues';
import AccessDenied from 'views/accessDenied';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { formcardSectionPadding } from 'styles/componentStyle';
import { autoSort, convertTime12to24 } from 'utilities/scheduleAppointment';
import CheckoutForm from './stripElement';
import {
  useGetBookingLookup,
  useGetDeviceList,
  useGetProcedureList,
  useGetStaffList,
  useGetTimeSlots,
  usePostOnlineBookingIntent,
  usePostOnlineBookingTransaction,
  usePostSaveAppointment,
  usePostSendOtp,
  usePostVerifyOtp,
  useGetAvailableDates
} from './hooks';
import styles from './index.module.scss';
import { addHoursToTime } from 'utilities/formatTime';
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';
import SaveCardDetails from './saveCardDetails';

const steps = [
  translateLanguage(`OnlineBooking.${OnlineBookingContent.SELECTAPPOINTMENT}`),
  translateLanguage(
    `OnlineBooking.${OnlineBookingContent.ENTERPATIENTDETAILS}`,
  ),
];
const initialData = {
  id: 0,
  title: '',
  onlineBookingAmount: 0,
};

interface TimeSlots {
  availableSlots: string[];
  firstName: string;
  lastName: string;
  staffId: number;
}

export const OnlineBooking: FC = () => {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();
  const encodedclientId = searchParams.get('ci');
  const encodedSecretKey = searchParams.get('sk');
  const searchForm = useRef(0)
  const [currentStepperIndex, setCurrentStepperIndex] = useState<number>(0);
  const [queryStringToApi, setQueryStringToApi] = useState<string>('');
  const [displaySlots, setDisplaySlots] = useState<boolean>(false);
  const [isStripeActive, setIsStripeActive] = useState<boolean>(false);
  const [isUniversalAmountActive, setIsUniversalAmountActive] =
    useState<boolean>(false);
  const [otpPopupOpen, setOtpPopupOpen] = useState<boolean>(false);
  const [isBooked, setIsBooked] = useState<boolean>(false);
  const [saveAppointmentData, setSaveAppointmentData] = useState<any>();
  const [saveOnlineBookingTransactionData, setOnlineBookingTransactionData] =
    useState<any>();
  const [sendOtpData, setSendOtpData] = useState<any>();
  const [onlineBookingIntentData, setOnlineBookingIntentData] = useState<any>();
  const [verifyOtpData, setVerifyOtpData] = useState<any>();
  const [locationObj, setLocationObj] = useState<DropdownOption>(initialData);
  const [staffObj, setStaffObj] = useState<any>(initialData);
  const [procedureObj, setProcedureObj] = useState<any>({
    id: 0,
    title: '',
    duration: 0,
    onlineBookingAmount: 0,
    procedureCost: null
  });
  const [selectedDate, setSelectedDate] = useState({
    formatedDate: formatDateDayDDMM(String(new Date())),
    originalFormatDate: new Date(),
    dateTime: '',
    dateError: false,
  });
  const [dobError, setDobError] = useState(false);
  const [categoryList, setCategoryList] = useState<any[]>([]);
  const [treatmentList, setTreatmentList] = useState<any[]>([]);
  const [procedureList, setProcedureList] = useState<any[]>([]);
  const [staffList, setStaffList] = useState<any[]>([]);
  const clientId = decodedData(encodedclientId || '');
  const secretKey = decodedData(encodedSecretKey || '');
  const [location, setLocation] = useState<any>([]);
  const [isPayment, setIsPayment] = useState<boolean>(false);
  const [isGetCardDetails, setIsGetCardDetails] = useState<boolean>(false);
  if (!encodedclientId || !encodedSecretKey || !clientId || !secretKey) {
    return <AccessDenied />;
  }

  const [stripePromise, setStripePromise] = useState<any>(null);
  const [clientSecret, setClientSecret] = useState<any>('');
  const [onlineAmount, setOnlineAmount] = useState<any>(0);
  const [deviceListQuery, setDeviceListQuery] = useState<any>('');
  const [deviceList, setDeviceList] = useState<any[]>([]);
  const [dateList, setDateList] = useState<Date[]>([]);
  const [availableSlots, setAvailableSlots] = useState<TimeSlots[]>([]);
  const [timeSlot, setTimeSlot] = useState<any>();
  const [isSlotAvailable, setIsSlotAvailable] = useState<boolean>(false)
  const unavailableDates = [new Date('04-09-2024'), new Date('04-10-2024'), new Date('04-11-2024'), new Date('04-04-2024'), new Date('04-05-2024'), new Date('04-06-2024'), new Date('04-07-2024'), new Date('04-08-2024')]
  const [availableDates, setAvailableDates] = useState<string[]>([])
  const [mergedAvailableDates, setMergedAvailableDates] = useState<string[]>([])
  const [appointmentMonth, setAppointmentMonth] = useState<string>(moment(new Date()).format(DATEFORMAT))
  const [stripeCustomerID, setStripeCustomerID] = useState<string>('')
  const [fetchedCategory, setFetchedCategory] = useState<boolean>(false)
  
  const formMethods = useForm<any>({
    mode: 'onChange',
    resolver:
      currentStepperIndex === 0
        ? yupResolver(onlineBookingSearchSchema)
        : yupResolver(onlineBookingAppointmentSchema),
    defaultValues:
      currentStepperIndex === 0
        ? onlineBookingSearchDefaultValues
        : onlineBookingAppointmentDefaultValues,
  });

  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    reset,
    formState: { errors },
  } = formMethods;

  const mobileNumber = useWatch({
    control,
    name: `${OnlineBookingContent.PHONENUMBER}`,
  });
  const otp = useWatch({
    control,
    name: `${OnlineBookingContent.OTP}`,
  });
  const dob = useWatch({
    control,
    name: `${OnlineBookingContent.DATEOFBIRTH}`,
  });

  const onSuccessBookingLookup = (data: any) => {
    setIsStripeActive(data.isStripeActive);
    setIsUniversalAmountActive(data.isUniversalAmountActive);
    setStripePromise(
      loadStripe(data.publishableKey, {
        stripeAccount: data.stripeAccountId,
      }),
    );
    if (data?.clinicLocationDetail.length === 0) {
      queryClient.setQueryData(['toast-message'], {
        message: `${translateLanguage(
          `OnlineBooking.${OnlineBookingContent.LOCATIONERROR}`,
        )}`,
        type: 'error',
      });
    } else if (data?.clinicLocationDetail.length === 1) {
      setValue(
        `${OnlineBookingContent.LOCATIONID}`,
        data?.clinicLocationDetail[0].id,
      );
      setLocation(data?.clinicLocationDetail);
      setProcedureList([]);
      setLocationObj({
        id: data?.clinicLocationDetail[0].id,
        title: data?.clinicLocationDetail[0].title,
      });
      resetProcedureStaff();
    } else {
      setLocation(data?.clinicLocationDetail);
    }
  };

  const bookingLookup = useGetBookingLookup(
    {
      clientId,
      timeStamp: moment().format(),
      secretKey,
    },
    onSuccessBookingLookup,
  );

  const onSuccessGetStaffList = (data: any) => {
    if (data.length === 0) {
      queryClient.setQueryData(['toast-message'], {
        message: `${translateLanguage(
          `OnlineBooking.${OnlineBookingContent.RECORDNOTFOUND}`,
        )}`,
        type: 'error',
      });
    } else if (data.length === 1) {
      setValue(`${OnlineBookingContent.STAFFID}`, data[0].id);
      setStaffList(data);
      setStaffObj({ id: data[0].id, title: data[0].fullName });
      setDisplaySlots(false);
    } else {
      setStaffList(data);
    }
  };
  const getStaffList = useGetStaffList(
    {
      procedureId: procedureObj?.id,
      locationId: locationObj?.id,
      clientId,
      timeStamp: moment().format(),
      secretKey,
    },
    onSuccessGetStaffList,
  );

  const onSuccessGetCategoryList = (data: any) => {
    if (data.length === 0) {
      queryClient.setQueryData(['toast-message'], {
        message: `${translateLanguage(
          `OnlineBooking.${OnlineBookingContent.TREATMENTNOTFOUND}`,
        )}`,
        type: 'error',
      });
    } else {
      setCategoryList(data)
      resetProcedureStaff()
      setFetchedCategory(true)
    }
  }

  const onSuccessGetProcedureList = (data: any) => {
    if (data.length === 0) {
      queryClient.setQueryData(['toast-message'], {
        message: `${translateLanguage(
          `OnlineBooking.${OnlineBookingContent.TREATMENTNOTFOUND}`,
        )}`,
        type: 'error',
      });
    } else if (data.length === 1) {
      setValue(`${OnlineBookingContent.PROCEDUREID}`, data[0].id);
      setProcedureList(data);
      setStaffList([]);
      setProcedureObj({
        id: data[0].id,
        title: data[0].description,
        duration:
          data[0].defaultTimePerAppt ||
          bookingLookup?.data?.defaultTimePerAppointment,
        onlineBookingAmount: data[0].onlineBookingAmount,
        procedureCost: data[0].procedureCost
      });
      resetStaff();
    } else {
      setProcedureList(data);
    }
  };
  const getProcedureList = useGetProcedureList(
    {
      locationId: locationObj?.id,
      clientId,
      timeStamp: moment().format(),
      secretKey,
    },
    onSuccessGetCategoryList,
  );

  const onSuccessTimeSlots = (data: any) => {
    if (data.length === 0) {
      queryClient.setQueryData(['toast-message'], {
        message: `${translateLanguage(
          `OnlineBooking.${OnlineBookingContent.TIMESLOTNOTFOUND}`,
        )}`,
        type: 'error',
      });
      setIsSlotAvailable(false)
      setAvailableSlots([])
    } else {
      let numberOfSlots = 0;
      data.map((elm: any) => {
        numberOfSlots += elm.availableSlots.length
      })
      numberOfSlots > 0 ? setIsSlotAvailable(true) : setIsSlotAvailable(false)
      setAvailableSlots(data)
    }
  };
  const onErrorTimeSlots = () => {
    setIsSlotAvailable(false)
    setAvailableSlots([])
  }
  const useTimeSlots = useGetTimeSlots(
    {
      queryStringToApi,
      timeStamp: moment().format(),
      clientId,
      secretKey,
    },
    onSuccessTimeSlots,
    onErrorTimeSlots
  );

  const onPostSaveAppointmentSuccess = (data: any) => {
    setOtpPopupOpen(false);
    setIsBooked(true);
  };
  const onPostSaveAppointmentError = () => {
    setOtpPopupOpen(false);
    setValue(`${OnlineBookingContent.OTP}`, '');
  };
  const postSaveAppointment = usePostSaveAppointment(
    onPostSaveAppointmentSuccess,
    {
      saveAppointmentData,
      clientId,
      timeStamp: moment().format(),
      secretKey,
      amount: onlineAmount,
    },
    onPostSaveAppointmentError,
    stripeCustomerID
  );

  const postOnlineBookingTransaction = usePostOnlineBookingTransaction({
    saveOnlineBookingTransactionData,
    clientId,
    timeStamp: moment().format(),
    secretKey,
  });

  const onPostSendOtpSuccess = (data: any) => {
    if (data?.data?.isValid) {
      setOtpPopupOpen(true);
    } else {
      queryClient.setQueryData(['toast-message'], {
        message: data?.data?.errors[0],
        type: 'error',
      });
    }
  };
  const postSendOtp = usePostSendOtp(onPostSendOtpSuccess, {
    sendOtpData,
    clientId,
    timeStamp: moment().format(),
    secretKey,
  });

  const saveAppointment = (paymentResponse?: any) => {
    setSaveAppointmentData(
      bookingPrepare(
        getValues,
        {
          timeSlot: selectedDate.dateTime,
          procedureName: procedureObj.title,
          procedureDuration: procedureObj.duration,
          bookingDate: selectedDate.originalFormatDate,
          selectedDevice: deviceList,
        },
        paymentResponse,
      ),
    );
  };

  const saveOnlineBookingTransaction = (response?: any) => {
    setOnlineBookingTransactionData(
      bookingPrepare(
        getValues,
        {
          timeSlot: selectedDate.dateTime,
          procedureName: procedureObj.title,
          procedureDuration: procedureObj.duration,
          bookingDate: selectedDate.originalFormatDate,
          selectedDevice: deviceList,
        },
        response,
      ),
    );
  };
  const onPostVerifyOtpSuccess = (data: any) => {
    if (data?.data?.isValid) {
      // isStripeActive && procedureObj.onlineBookingAmount > 0
      //   ? onlinePaymentIntent(procedureObj.onlineBookingAmount)
      //   : saveAppointment();

      if (isStripeActive) {
        if (isUniversalAmountActive) {
          if (bookingLookup?.data?.onlineBookingAmount > 0) {
            onlinePaymentIntent(bookingLookup?.data?.onlineBookingAmount);
          } else {
            setIsGetCardDetails(true);
          }
        } else if (procedureObj.onlineBookingAmount > 0) {
          onlinePaymentIntent(procedureObj.onlineBookingAmount);
        } else {
          setIsGetCardDetails(true);
        }
      } else {
        saveAppointment();
      }
    } else {
      queryClient.setQueryData(['toast-message'], {
        message: data?.data?.errors[0],
        type: 'error',
      });
    }
  };
  const postVerifyOtp = usePostVerifyOtp(onPostVerifyOtpSuccess, {
    verifyOtpData,
    clientId,
    timeStamp: moment().format(),
    secretKey,
  });

  const onSuccessPostOnlineBookingIntent = (onlineBookingIntent: any) => {
    setClientSecret(onlineBookingIntent?.data?.client_secret);
    setIsPayment(true);
    setStripeCustomerID(onlineBookingIntent?.data?.customer)
  };

  const onlineBookingIntent = usePostOnlineBookingIntent(
    onlineBookingIntentData,
    onSuccessPostOnlineBookingIntent,
  );

  const onSuccessGetDeviceList = (data: any) => {
    setDeviceListQuery('');
    setDeviceList(data?.equipment || []);
    if (!data?.isAllAvailable && data?.message) {
      queryClient.setQueryData(['toast-message'], {
        message: data?.message,
        type: 'error',
      });
    }
  };

  const getDevice = useGetDeviceList(deviceListQuery, onSuccessGetDeviceList);

  useEffect(() => {
    saveAppointmentData && postSaveAppointment?.mutate(saveAppointmentData);
  }, [saveAppointmentData]);

  useEffect(() => {
    saveOnlineBookingTransactionData &&
      postOnlineBookingTransaction?.mutate(saveOnlineBookingTransactionData);
  }, [saveOnlineBookingTransactionData]);

  useEffect(() => {
    sendOtpData && postSendOtp.mutate(sendOtpData);
  }, [sendOtpData]);

  useEffect(() => {
    verifyOtpData && postVerifyOtp.mutate(verifyOtpData);
  }, [verifyOtpData]);

  useEffect(() => {
    setValue(`${OnlineBookingContent.DATEOFBIRTH}`, null);
  }, [currentStepperIndex]);

  useEffect(() => {
    if (fetchedCategory && categoryList.length) {
      setValue(OnlineBookingContent.CATEGORY, 0)
      handleCategoryChange(0)
      setFetchedCategory(false)
    }
  }, [fetchedCategory, categoryList])

  const resetStaff = () => {
    setStaffObj(initialData);
    setValue(`${OnlineBookingContent.STAFFID}`, '');
    setDisplaySlots(false);
  };

  const resetCategory = () => {
    setValue(`${OnlineBookingContent.CATEGORY}`, '');
    setCategoryList([])
  }

  const resetProcedureStaff = () => {
    resetStaff();
    setStaffList([]);
    setProcedureObj({ ...initialData, duration: 0 });
  };

  const handleLocationChange = (id: string) => {
    resetCategory()
    setProcedureList([]);
    const locationData = bookingLookup?.data?.clinicLocationDetail.filter(
      (location: any) => location.id === id,
    )[0];
    setLocationObj({ id: locationData.id, title: locationData.title });
    resetProcedureStaff();
  };

  const handleCategoryChange = (id: any) => {
    resetProcedureStaff()
    let procedureList = categoryList.find(x => x.id === id).procedure
    setTreatmentList(procedureList)
    onSuccessGetProcedureList(procedureList)
    getStaffList.refetch()
  }

  const handleTreatmentChange = (id: string) => {
    setStaffList([]);
    const procedureData = treatmentList?.filter(
      (procedure: any) => procedure.id === id,
    )[0];
    setProcedureObj({
      id: procedureData.id,
      title: procedureData.description,
      duration:
        procedureData.defaultTimePerAppt ||
        bookingLookup?.data?.defaultTimePerAppointment,
      onlineBookingAmount: procedureData.onlineBookingAmount,
      procedureCost: procedureData.procedureCost
    });
    resetStaff();
  };

  const handleStaffChange = (id: string) => {
    const staffData = getStaffList?.data?.filter((staff: any) => {
      if (Number(id) === 0) {
        return staff.id !== id
      } else
        return staff.id === id
    });
    if (staffData.length === 1) {
      setStaffObj({ id: staffData[0].id, title: staffData[0].fullName });
    } else if (staffData.length > 1) {
      let allIds = staffData.reduce((acc: any, curr: any) => acc + ',' + curr.id, "").replace(",", "")
      setStaffObj({ id: allIds, title: "" });
    }
    setDisplaySlots(false);

    setAppointmentMonth((moment(getValues('appointmentDate')).format(DATEFORMAT)))
  };

  const getSearchQuery = (date: any) => {
    const searchQuery = `AppointmentDate=${date ? moment(date).format(DATEFORMAT) : ''
      }&StaffId=${staffObj.id ? staffObj.id : ''}&ProcedureId=${procedureObj.id ? procedureObj.id : ''
      }&LocationId=${locationObj.id ? locationObj.id : 1}`;
    setQueryStringToApi(`${searchQuery}&TimeStamp=${moment().format()}`);
  };

  const getNextDate = (date: any) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    setSelectedDate({
      ...selectedDate,
      formatedDate: formatDateDayDDMM(String(newDate)),
      originalFormatDate: newDate,
    });
    getSearchQuery(newDate);
  };

  const getPreviousDate = (date: any) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() - 1);
    setSelectedDate({
      ...selectedDate,
      formatedDate: formatDateDayDDMM(String(newDate)),
      originalFormatDate: newDate,
    });
    getSearchQuery(newDate);
  };

  const getTodayDate = () => {
    setSelectedDate({
      ...selectedDate,
      formatedDate: formatDateDayDDMM(String(new Date())),
      originalFormatDate: new Date(),
    });
    getSearchQuery(new Date());
  };

  const selectDate = (date: any) => {
    const currDate = new Date(date);
    setSelectedDate({
      ...selectedDate,
      formatedDate: formatDateDayDDMM(String(currDate)),
      originalFormatDate: currDate,
    });
    getSearchQuery(currDate);
  }

  const onSubmit = (data: any) => {
    if (currentStepperIndex === 1) {
      sendOtp();
    } else if (
      DateFormaterYMD(data.appointmentDate) <
      DateFormaterYMD(String(new Date())) ||
      DateFormaterYMD(String(data.appointmentDate)) >
      DateFormaterYMD(String(moment(new Date()).add(1, 'years')))
    ) {
      setDisplaySlots(false);
      setSelectedDate({
        ...selectedDate,
        dateError: true,
      });
    } else if (!mergedAvailableDates.includes(moment(data.appointmentDate).format(DATEFORMAT))) {
      setDisplaySlots(false);
      setSelectedDate({
        ...selectedDate,
        dateError: true,
      });
    }
    else {
      setDisplaySlots(true);
      setSelectedDate({
        ...selectedDate,
        formatedDate: formatDateDayDDMM(
          getValues(`${OnlineBookingContent.APPOINTMENTDATE}`),
        ),
        originalFormatDate: getValues(
          `${OnlineBookingContent.APPOINTMENTDATE}`,
        ),
      });
      getDateList(data.appointmentDate)
      getSearchQuery(data.appointmentDate);
    }
  };

  const getDateList = (date: Date) => {
    let dates: Date[] = [date]
    let currDate = date
    let isNewMonth = false
    let newMonth = appointmentMonth
    for (let i = 0; i < 4; i++) {
      currDate = new Date(currDate.getTime() + 24 * 60 * 60 * 1000)
      dates.push(currDate)
      if (new Date(currDate).getMonth() !== new Date(appointmentMonth).getMonth()) {
        isNewMonth = true
        newMonth = moment(currDate).format(DATEFORMAT)
      }
    }
    if (isNewMonth) {
      setAppointmentMonth(newMonth)
    }
    setDateList(dates);
  }

  const getPrevDateList = () => {
    const prevDate = new Date(dateList[0].getTime() - 24 * 60 * 60 * 1000)
    getDateList(prevDate)
  }

  const getNextDateList = () => {
    getDateList(dateList[1]) //passing the second date as ref to get the date list
  }

  const selectTimeSlot = () => {
    getDeviceList({
      ...selectedDate,
      dateTime: timeSlot,
    });
    setCurrentStepperIndex(1);
    setSelectedDate({
      ...selectedDate,
      dateTime: timeSlot,
    });
  }

  const onClearDeviceList = () => {
    setDeviceListQuery('');
    setDeviceList([]);
  }

  const onClear = () => {
    onClearDeviceList();
    setDisplaySlots(false);
    setCategoryList([])
    setStaffList([]);
    setProcedureList([]);
    setLocationObj(initialData);
    reset(onlineBookingSearchDefaultValues);
  };

  const cancelAppointment = () => {
    onClearDeviceList();
    setCurrentStepperIndex(0);
  };
  const closeOtpPopup = () => {
    setValue(`${OnlineBookingContent.OTP}`, '');
    setOtpPopupOpen(false);
  };

  const sendOtp = () => {
    if (DateFormaterYMD(dob) < DateFormaterYMD(String(new Date()))) {
      setSendOtpData({
        mobileNumber: formattedMobNumber(mobileNumber),
        otp: '',
      });
    } else {
      setDobError(true);
    }
  };

  const verifyOtp = () =>
    setVerifyOtpData({
      mobileNumber: formattedMobNumber(mobileNumber),
      otp,
    });

  const bookAnotherAppointment = () => {
    setIsBooked(false);
    setIsPayment(false);
    setIsGetCardDetails(false);
    setCurrentStepperIndex(0);
    onClear();
    bookingLookup.refetch();
  };

  const onlinePaymentIntent = (onlineBookingAmount: Number) => {
    setOnlineAmount(onlineBookingAmount);
    setOnlineBookingIntentData({
      cid: encodedclientId,
      onlineBookingAmount,
      procedureId: procedureObj.id,
      firstName: getValues('firstName'),
      lastName: getValues('lastName'),
      primaryPhone1: formattedMobNumber(mobileNumber),
      primaryemailaddress: getValues('email'),
    });
  };

  useEffect(() => {
    onlineBookingIntentData &&
      onlineBookingIntent.mutate(onlineBookingIntentData);
  }, [onlineBookingIntentData]);

  const handlePaymentResponse = (data: any, isSuccess: boolean) => {
    isSuccess ? saveAppointment(data) : saveOnlineBookingTransaction(data);
  };


  const handleCardDetails = (data: any) => {
    // isSuccess ? saveAppointment(data) : saveOnlineBookingTransaction(data);

    setSaveAppointmentData(
      bookingPrepare(
        getValues,
        {
          timeSlot: selectedDate.dateTime,
          procedureName: procedureObj.title,
          procedureDuration: procedureObj.duration,
          bookingDate: selectedDate.originalFormatDate,
          selectedDevice: deviceList,
        },
        '',
        data?.id,
      ),
    );
  };

  const getDeviceList = (data: any) => {
    const formattedAppointmentDate = moment(data.originalFormatDate).format(
      DATE_FORMAT_MDY,
    );
    const appointmentStartDate = `${formattedAppointmentDate} ${convertTime12to24(
      data.dateTime,
    )}`;

    const appointmentEndDate = `${formattedAppointmentDate} ${addHoursToTime(
      appointmentStartDate,
      procedureObj.duration,
    )}`;
    setDeviceListQuery(
      `${procedureObj?.id
      }/${appointmentStartDate}/${appointmentEndDate}/${encodedData(clientId)}`,
    );
  };

  const onSuccessAvailableDates = (data: string[]) => {
    let allDates = mergedAvailableDates
    let dates = data.map((elm: any) => {
      let temp = elm.split("T")[0]
      if (!allDates.includes(temp))
        allDates.push(temp)
      return temp
    })
    setAvailableDates(dates)
    setMergedAvailableDates(allDates)
  }

  const useAvailableDates = useGetAvailableDates(
    {
      StaffId: staffObj.id,
      LocationId: locationObj.id,
      ProcedureId: procedureObj.id,
      queryStringToApi,
      AppointmentDate: appointmentMonth,
      timeStamp: moment().format(),
      clientId,
      secretKey,
    },
    onSuccessAvailableDates,
  );

  const onMonthChange = (data: any) => {
    let temp = (moment(new Date(data)).format(DATEFORMAT))
    setAppointmentMonth(temp)
  }

  useEffect(() => {
    setMergedAvailableDates([])
    setAvailableDates([])
    if (staffObj.id) {
      useAvailableDates.refetchStaffLocation()
    }
  }, [staffObj])

  useEffect(() => {
    if (staffObj.id) {
      if (useAvailableDates.isMonthDataRefetching || useAvailableDates.isMonthDataLoading) {
        useAvailableDates.stopFetchingMonthData()
      }
      useAvailableDates.refetchStaffLocation()
    }
  }, [appointmentMonth])

  const otpPopup = otpPopupOpen && (
    <FormOtpPopUp
      open={otpPopupOpen}
      title={translateLanguage(
        `OnlineBooking.${OnlineBookingContent.ENTEROTP}`,
      )}
      onClose={closeOtpPopup}
      theme={theme}
      handleClick={verifyOtp}
      disableButton={otp?.length < 4}
      buttonTitle={translateLanguage(
        `OnlineBooking.${OnlineBookingContent.DONE}`,
      )}
      loading={
        postVerifyOtp.isLoading ||
        postSaveAppointment.isLoading ||
        onlineBookingIntent.isLoading
      }
      underTitleText={`${translateLanguage(
        `OnlineBooking.${OnlineBookingContent.VERIFICATIONSENT}`,
      )} XXX-XXX-${formattedMobNumber(mobileNumber).slice(-4)}`}
    >
      <Grid container sx={{ mt: '16px' }}>
        <Grid item xs={12} display="flex" justifyContent="center">
          <FormOtpField
            {...formMethods}
            name={OnlineBookingContent.OTP}
            handleBlur={() => { }}
          />
        </Grid>
        <Grid item xs={12}>
          <Grid container className={styles.resendGrid}>
            <Grid item display="flex">
              <Typography className={styles.otpText}>
                {translateLanguage(
                  `OnlineBooking.${OnlineBookingContent.DIDNTRECEIVE}`,
                )}
              </Typography>
              <FormOnlineBookingButton
                name={OnlineBookingContent.RESENDOTP}
                label={translateLanguage(
                  `OnlineBooking.${OnlineBookingContent.RESENDOTP}`,
                )}
                variant="text"
                theme={theme}
                onClick={sendOtp}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </FormOtpPopUp>
  );

  if (bookingLookup?.isLoading) {
    return <Loader />;
  }

  return (
    <Grid className={`htmlForm ${styles.mainContainer}`}>
      {isBooked ? (
        <Grid item container xs={12} justifyContent={'center'} mt={5}>
          <FormSectionOb
            sectionTitle={`OnlineBooking.${OnlineBookingContent.YOURAPPOINTMENT}`}
            bookingBackground
            theme={theme}
          >
            <Grid container justifyContent={'center'}>
              <Grid item textAlign={'center'}>
                <Typography>Success! Thank you for choosing {locationObj.title}.</Typography>
                <Typography>We have sent you a confirmation at your email.</Typography>
                <Grid item className={styles.confirmationInfo}>
                  <Grid item display={'flex'} justifyContent={'space-between'} alignItems={'baseline'}>
                    <Typography className={styles.treatment}>
                      {procedureObj.title}
                    </Typography>
                    {procedureObj.procedureCost === null ? <></> :
                      <Typography className={styles.cost} ml={1}>${procedureObj.procedureCost}</Typography>
                    }
                  </Grid>
                  <Grid item display={'flex'} justifyContent={'space-between'} alignItems={'baseline'}>
                    <Typography className={styles.appointmentValues}>
                      {`${selectedDate.formatedDate} ${translateLanguage(
                        `OnlineBooking.${OnlineBookingContent.AT}`,
                      )} ${selectedDate.dateTime}`}
                    </Typography>
                    <Typography className={styles.duration}>{(procedureObj.duration * 60).toFixed(1)} mins</Typography>
                  </Grid>
                </Grid>
                <Grid container direction="row" justifyContent="center" alignItems="center" pt={2}>
                  <Grid item>
                    <Typography className={styles.profilePic} mr={2}>
                      <PersonIcon fontSize='inherit' />
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={styles.treatment}>
                      Practioner
                    </Typography>
                    <Typography className={styles.staffName}>
                      {staffObj.title}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} justifyContent={'center'} mt={4}>
                  <FormOnlineBookingButton
                    name={OnlineBookingContent.BOOKANOTHERAPPOINTMENT}
                    label={translateLanguage(
                      `OnlineBooking.${OnlineBookingContent.BOOKANOTHERAPPOINTMENT}`,
                    )}
                    variant="contained"
                    theme={theme}
                    onClick={bookAnotherAppointment}
                  />
                </Grid>
              </Grid>
            </Grid>
          </FormSectionOb>
        </Grid>
      ) : isPayment ? (
        <Grid item container xs={12} justifyContent={'center'} mt={5}>
          <FormSectionOb
            sectionTitle={`OnlineBooking.${OnlineBookingContent.BOOKINGDEPOSIT}`}
            bookingBackground
            theme={theme}
          >
            <Grid container className={styles.confirmedBooking} p={2}>
              <Grid item xs={12}>
                {clientSecret && stripePromise && (
                  <Elements stripe={stripePromise} options={{ clientSecret }}>
                    <CheckoutForm
                      paymentAmount={onlineAmount}
                      handlePaymentResponse={handlePaymentResponse}
                    />
                  </Elements>
                )}
              </Grid>
            </Grid>
          </FormSectionOb>
        </Grid>
      ) : isGetCardDetails ? (
        <Grid item container xs={12} justifyContent={'center'} mt={5}>
          <Grid item xs={12} md={8} lg={6}>
            <FormSectionOb
              sectionTitle={`OnlineBooking.${OnlineBookingContent.SAVECARD}`}
              bookingBackground
              theme={theme}
            >
              <Grid container className={styles.confirmedBooking} p={2}>
                <Alert severity="info" sx={{ color: '#0B5FD8', fontWeight: '500' }}>
                  {bookingLookup?.data?.onlineBookingCardSaveDescription}
                </Alert>
                {stripePromise && (
                  <Elements stripe={stripePromise}>
                    <SaveCardDetails handleCardResponse={handleCardDetails} />
                  </Elements>
                )}
              </Grid>
            </FormSectionOb>
          </Grid>
        </Grid>
      ) : (
        <>
          {otpPopup}
          <Stepper activeStep={currentStepperIndex} className={styles.stepper}>
            {steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};
              return (
                <Step key={label} className={styles.stepStyle} {...stepProps}>
                  <StepButton className={styles.stepButton} disabled={false}>
                    <StepLabel className={styles.stepLabel} {...labelProps}>{label}</StepLabel>
                  </StepButton>
                </Step>
              );
            })}
          </Stepper>
          {currentStepperIndex === 0 ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box className={styles.section}>
                <FormSectionOb
                  sectionTitle={`OnlineBooking.${OnlineBookingContent.SEARCH}`}
                  bookingBackground
                  theme={theme}
                >
                  <Grid container sx={{ mb: theme.spacing(1) }} spacing={2}>
                    <Grid item xs={12} md={2.4}>
                      <FormDropdownOb
                        {...formMethods}
                        name={OnlineBookingContent.LOCATIONID}
                        label={translateLanguage(
                          `OnlineBooking.${OnlineBookingContent.LOCATION}`,
                        )}
                        width={240}
                        theme={theme}
                        variant={'standard'}
                        handleChange={(id) => handleLocationChange(id)}
                      >
                        {location &&
                          location.map((option: DropdownOption) => (
                            <MenuItem
                              key={option.id}
                              value={option.id}
                              sx={{ width: '100%' }}
                            >
                              {option.title}
                            </MenuItem>
                          ))}
                      </FormDropdownOb>
                    </Grid>
                    <Grid item xs={12} md={2.4}>
                      <FormDropdownOb
                        {...formMethods}
                        name={OnlineBookingContent.CATEGORY}
                        label={translateLanguage(
                          `OnlineBooking.${OnlineBookingContent.CATEGORY}`,
                        )}
                        width={240}
                        theme={theme}
                        handleChange={(id) => handleCategoryChange(id)}
                      >
                        {autoSort(categoryList, 'categoryType')?.map(
                          (option: any) => (
                            <MenuItem
                              key={option.id}
                              value={option.id}
                              sx={{ width: '100%' }}
                            >
                              {option.categoryType}
                            </MenuItem>
                          ),
                        )}
                      </FormDropdownOb>
                    </Grid>
                    <Grid item xs={12} md={2.4}>
                      <FormDropdownOb
                        {...formMethods}
                        name={OnlineBookingContent.PROCEDUREID}
                        label={translateLanguage(
                          `OnlineBooking.${OnlineBookingContent.TREATMENT}`,
                        )}
                        width={240}
                        theme={theme}
                        handleChange={(id) => handleTreatmentChange(id)}
                      >
                        {autoSort(procedureList, 'description')?.map(
                          (option: any) => (
                            <MenuItem
                              key={option.id}
                              value={option.id}
                              sx={{ width: '100%' }}
                            >
                              {option.description}
                            </MenuItem>
                          ),
                        )}
                      </FormDropdownOb>
                    </Grid>
                    <Grid item xs={12} md={2.4}>
                      <FormDropdownOb
                        {...formMethods}
                        name={OnlineBookingContent.STAFFID}
                        label={translateLanguage(
                          `OnlineBooking.${OnlineBookingContent.STAFFNAME}`,
                        )}
                        width={240}
                        theme={theme}
                        handleChange={(id) => {
                          handleStaffChange(id);
                        }}
                      >
                        {staffList?.map((option: any) => (
                          <MenuItem
                            key={option.id}
                            value={option.id}
                            sx={{ width: '100%' }}
                          >
                            {option.fullName}
                          </MenuItem>
                        ))}
                      </FormDropdownOb>
                    </Grid>
                    <Grid item xs={12} md={2.4}>
                      <FormAvailableDatesOb
                        {...formMethods}
                        name={OnlineBookingContent.APPOINTMENTDATE}
                        label={translateLanguage(
                          `OnlineBooking.${OnlineBookingContent.DATE}`,
                        )}
                        theme={theme}
                        textFieldStyle={{ width: '100%' }}
                        bookingDate
                        minDate={new Date()}
                        onError={(errorMsg: any) => {
                          setSelectedDate({
                            ...selectedDate,
                            dateError:
                              errorMsg === `${OnlineBookingContent.INVALIDATE}`,
                          });
                        }}
                        maxDate={moment(new Date()).add(1, 'years')}
                        enableDates={mergedAvailableDates}
                        onMonthChange={onMonthChange}
                        onYearChange={onMonthChange}
                        disable={!!!staffObj.id}
                        isLoading={useAvailableDates.isMonthDataLoading || useAvailableDates.isMonthDataRefetching}
                      />
                      <FormHelperText
                        error={errors.appointmentDate || selectedDate.dateError}
                      >
                        {selectedDate.dateError
                          ? `${translateLanguage(
                            `OnlineBooking.${OnlineBookingContent.UNAVAILABLEDATE}`,
                          )}`
                          : errors.appointmentDate?.message}
                      </FormHelperText>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item>
                      <FormOnlineBookingButton
                        name={OnlineBookingContent.SEARCH}
                        label={translateLanguage(
                          `OnlineBooking.${OnlineBookingContent.SEARCHSELECTION}`,
                        )}
                        variant="contained"
                        theme={theme}
                        submit
                      />
                    </Grid>
                    <Grid item>
                      <FormOnlineBookingButton
                        name={OnlineBookingContent.CLEARALL}
                        label={translateLanguage(
                          `OnlineBooking.${OnlineBookingContent.CLEARALL}`,
                        )}
                        variant="outlined"
                        theme={theme}
                        onClick={onClear}
                      />
                    </Grid>
                  </Grid>
                </FormSectionOb>
                {displaySlots &&
                  (<FormSectionOb
                    sectionTitle={translateLanguage(
                      `OnlineBooking.${OnlineBookingContent.CHOOSEYOURTIME}`,
                    )}
                    bookingBackground
                    theme={theme}
                  >
                    <Grid item container xs={12}>
                      <Grid item container xs={12} md={3}>
                        <Grid item xs={12} className={styles.subSection} p={2} mr={2}>
                          <Grid item className={styles.appointmentInfo}>
                            <Grid item display={'flex'} justifyContent={'space-between'} alignItems={'baseline'}>
                              <Typography className={styles.treatment}>
                                {procedureObj.title}
                              </Typography>
                              {procedureObj.procedureCost === null ?
                                <Typography className={styles.duration}>{(procedureObj.duration * 60).toFixed(1)} mins</Typography>
                                :
                                <Typography className={styles.cost}>${procedureObj.procedureCost}</Typography>
                              }
                            </Grid>
                            {procedureObj.procedureCost === null ? <></> :
                              <Typography className={styles.duration}>{(procedureObj.duration * 60).toFixed(1)} mins</Typography>
                            }
                          </Grid>
                          <Grid container direction="row" justifyContent="left" alignItems="center" pt={2}>
                            <Grid item>
                              <Typography className={styles.profilePic} mr={2}>
                                <PersonIcon fontSize='inherit' />
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography className={styles.treatment}>
                                Practioner
                              </Typography>
                              <Typography className={styles.staffName}>
                                {staffObj.title}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item container xs={12} md={9}>
                        <Grid container className={styles.subSection} p={2}>
                          <Grid container justifyContent="center">
                            <Grid item xs={12}>
                              <Box
                                display="flex"
                                alignItems="flex-start"
                                justifyContent="center"
                              >
                                <Box>
                                  <IconButton
                                    className={styles.backArrow}
                                    onClick={() =>
                                      getPrevDateList()
                                    }
                                    disabled={
                                      DateFormaterYMD(String(new Date())) ===
                                      DateFormaterYMD(
                                        String(dateList[0]),
                                      )
                                    }
                                  >
                                    <ArrowBackIosNew />
                                  </IconButton>
                                </Box>
                                <Grid display={'flex'}
                                  className={styles.dateMain}
                                >
                                  {dateList?.map((date: any) => (
                                    <Box
                                      className={formatDateDayDDMM(String(date)) === selectedDate.formatedDate ? `${styles.dateTabs} ${styles.selected}`
                                        : !mergedAvailableDates.includes(moment(date).format(DATEFORMAT)) ? `${styles.dateTabs} ${styles.disabledDates}`
                                          : `${styles.dateTabs}`}
                                      onClick={() => selectDate(date)}
                                    >
                                      <Typography className={styles.treatment}>{moment(date).format('ddd')}</Typography>
                                      <Typography className={styles.staffName}>{moment(date).format('MMM D')}</Typography>
                                    </Box>
                                  ))}
                                </Grid>
                                <Box>
                                  <IconButton
                                    className={styles.forwardArrow}
                                    onClick={() =>
                                      getNextDateList()
                                    }
                                    disabled={
                                      DateFormaterYMD(
                                        String(moment(new Date()).add(1, 'years')),
                                      ) ===
                                      DateFormaterYMD(
                                        String(selectedDate.originalFormatDate),
                                      )
                                    }
                                  >
                                    <ArrowForwardIos />
                                  </IconButton>
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2} mt={2} className={styles.timeSlotBlock}>
                            {useTimeSlots?.isLoading || useTimeSlots?.isRefetching ? (
                              <Grid container justifyContent={'center'} alignItems={'center'} className={styles.timeSlotLoader}>
                                <Grid className={styles.slotsLoader}>
                                  <CircularProgress />
                                </Grid>
                              </Grid>
                            ) :
                              <>
                                {!isSlotAvailable ?
                                  <Grid container justifyContent={'center'} alignItems={'center'}>
                                    <Typography variant='h4'>No slots available!</Typography>
                                  </Grid> :
                                  (<>
                                    {availableSlots.map((data) => (
                                      <>
                                        {data.availableSlots.map((slot) => (
                                          <Grid item xs={6} sm={4} md={3} lg={2}>
                                            <Paper
                                              className={timeSlot === slot && staffObj.id === data.staffId ? `${styles.timeBox} ${styles.selected}` : `${styles.timeBox}`}
                                              onClick={() => {
                                                setTimeSlot(slot)
                                                setStaffObj({ id: data.staffId, title: `${data.firstName} ${data.lastName}` })
                                                setValue(`${OnlineBookingContent.STAFFID}`, data.staffId);
                                              }
                                              }
                                            >
                                              <Typography
                                                className={styles.treatment}>
                                                {slot}
                                              </Typography>
                                              <Typography className={styles.provider}>
                                                {data.firstName} {data.lastName}
                                              </Typography>
                                            </Paper>
                                          </Grid>
                                        ))}
                                      </>
                                    ))
                                    }
                                  </>)}

                              </>
                            }
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={0} md={3}></Grid>
                      <Grid item xs={12} md={9} pt={2}>
                        <FormOnlineBookingLoadingButton
                          name={'Select Time'}
                          label={'Select Time'}
                          variant="contained"
                          theme={theme}
                          loading={postSendOtp.isLoading && !otpPopupOpen}
                          onClick={selectTimeSlot}
                          submit
                        />
                      </Grid>
                    </Grid>
                  </FormSectionOb>)
                }
              </Box>
            </form>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2} className={styles.section}>
                <Grid item xs={12} className={styles.appointmentDetails}>
                  <FormSectionOb
                    sectionTitle={`OnlineBooking.${OnlineBookingContent.APPOINTMENTDETAILS}`}
                    bookingBackground
                    theme={theme}
                    style={formcardSectionPadding}
                    minHeight={300}
                  >
                    <Grid item container xs={12}>
                      <Grid item container xs={12} md={4}>
                        <Grid item xs={12} className={styles.subSection} p={2} mr={2}>
                          <Grid item>
                            <Grid item display={'flex'} justifyContent={'end'}>
                              <Typography className={styles.editAppointment} onClick={cancelAppointment}>
                                Modify Appointment
                                <EditIcon fontSize="inherit" />
                              </Typography>
                            </Grid>
                            <Grid item className={styles.appointmentInfo}>
                              <Grid item display={'flex'} justifyContent={'space-between'}>
                                <Typography className={styles.treatment}>
                                  {procedureObj.title}
                                </Typography>
                                {procedureObj.procedureCost === null ? <></> :
                                  <Typography className={styles.cost}>${procedureObj.procedureCost}</Typography>
                                }
                              </Grid>
                              <Grid item display={'flex'} justifyContent={'space-between'}>
                                <Typography className={styles.appointmentValues}>
                                  {`${selectedDate.formatedDate} ${translateLanguage(
                                    `OnlineBooking.${OnlineBookingContent.AT}`,
                                  )} ${selectedDate.dateTime}`}
                                </Typography>
                                <Typography className={styles.duration} sx={{ width: '69px', lineHeight: '25.5px' }}>{(procedureObj.duration * 60).toFixed(1)} mins</Typography>
                              </Grid>
                              <Typography className={styles.apptValues}>
                                {locationObj.title}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid container direction="row" justifyContent="left" alignItems="center" pt={2}>
                            <Grid item>
                              <Typography className={styles.profilePic} mr={2}>
                                <PersonIcon fontSize='inherit' />
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography className={styles.treatment}>
                                Practioner
                              </Typography>
                              <Typography className={styles.staffName}>
                                {staffObj.title}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item container xs={12} md={8}>
                        <Grid container className={styles.subSection} p={2}>
                          <Typography className={styles.subHeader} mb={2}>
                            Your Details
                          </Typography>
                          <Grid container sx={{ mb: theme.spacing(1) }} spacing={2}>
                            <Grid item xs={12} md={4}>
                              <FormTextFieldOb
                                {...formMethods}
                                name={OnlineBookingContent.FIRSTNAME}
                                label={translateLanguage(
                                  `OnlineBooking.${OnlineBookingContent.FIRSTNAME}`,
                                )}
                                width={245}
                                theme={theme}
                                handleBlur={() => { }}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <FormTextFieldOb
                                {...formMethods}
                                name={OnlineBookingContent.LASTNAME}
                                label={translateLanguage(
                                  `OnlineBooking.${OnlineBookingContent.LASTNAME}`,
                                )}
                                width={245}
                                theme={theme}
                                handleBlur={() => { }}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <FormDateOb
                                {...formMethods}
                                name={OnlineBookingContent.DATEOFBIRTH}
                                label={translateLanguage(
                                  `OnlineBooking.${OnlineBookingContent.DATEOFBIRTH}`,
                                )}
                                theme={theme}
                                textFieldStyle={{ width: '245px' }}
                                bookingDate
                                disableFuture
                                onError={(errorMsg: any) => {
                                  setDobError(
                                    errorMsg === `${OnlineBookingContent.INVALIDATE}`,
                                  );
                                }}
                              />
                              <FormHelperText
                                error={dobError || (errors.dob && !dob)}
                                sx={{ marginTop: '-6px' }}
                              >
                                {errors.dob && !dob
                                  ? errors.dob?.message
                                  : dobError
                                    ? `${translateLanguage(
                                      `OnlineBooking.${OnlineBookingContent.INVALIDATE}`,
                                    )}`
                                    : ''}
                              </FormHelperText>
                            </Grid>
                          </Grid>
                          <Grid container sx={{ mb: theme.spacing(1) }} spacing={2}>
                            <Grid item xs={12} md={4}>
                              <FormPhoneInputOb
                                {...formMethods}
                                name={OnlineBookingContent.PHONENUMBER}
                                label={translateLanguage(
                                  `OnlineBooking.${OnlineBookingContent.PHONENUMBER}`,
                                )}
                                width={245}
                                theme={theme}
                                countryCode={bookingLookup?.data?.countryCode}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <FormTextFieldOb
                                {...formMethods}
                                name={OnlineBookingContent.EMAIL}
                                label={translateLanguage(
                                  `OnlineBooking.${OnlineBookingContent.EMAIL}`,
                                )}
                                width={245}
                                theme={theme}
                                handleBlur={() => { }}
                              />
                            </Grid>

                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={0} md={4}></Grid>
                      <Grid item xs={12} md={8} pt={2}>
                        <FormOnlineBookingLoadingButton
                          name={OnlineBookingContent.BOOKAPPOINTMENT}
                          label={translateLanguage(
                            `OnlineBooking.${OnlineBookingContent.BOOKAPPOINTMENT}`,
                          )}
                          variant="contained"
                          theme={theme}
                          loading={postSendOtp.isLoading && !otpPopupOpen}
                          submit
                        />
                      </Grid>
                    </Grid>
                  </FormSectionOb>
                </Grid>
                {/* 
                <Grid item xs={12} lg={8} className={styles.patientDetails}>
                  <FormSectionOb
                    bookingBackground
                    theme={theme}
                    style={formcardSectionPadding}
                    minHeight={300}
                  >


                    <Grid container spacing={1}>
                      <Grid item>
                        <FormOnlineBookingLoadingButton
                          name={OnlineBookingContent.BOOKAPPOINTMENT}
                          label={translateLanguage(
                            `OnlineBooking.${OnlineBookingContent.BOOKAPPOINTMENT}`,
                          )}
                          variant="contained"
                          theme={theme}
                          loading={postSendOtp.isLoading && !otpPopupOpen}
                          submit
                        />
                      </Grid>
                      <Grid item>
                        <FormOnlineBookingButton
                          name={OnlineBookingContent.CANCEL}
                          label={translateLanguage(
                            `OnlineBooking.${OnlineBookingContent.CANCEL}`,
                          )}
                          variant="outlined"
                          theme={theme}
                          onClick={cancelAppointment}
                        />
                      </Grid>
                    </Grid>
                  </FormSectionOb>
                </Grid> */}
              </Grid>
            </form>
          )
          }
        </>
      )}
    </Grid >
  );
};

export default OnlineBooking;
